import { hctToHSL } from './color-conversion';

export default function writeExportCode(famData, lightnessData, prefsData) {
    let svg = writeSVGCode(famData, lightnessData, prefsData);
    let css = writeCSSCode(famData, prefsData);
    let tokens = writeDesignTokenCode(famData, prefsData);
    return {css:css,svg:svg,tokens:tokens};
}

function writeDesignTokenCode(famData, prefsData) {
    let outputString = '{\n';
    let duplicateManger = {
        counter: 2,
        number: 0
    };
    famData.forEach((family, famid, array) => {
        if (famid === array.length) {
            // dont use a comma
        }
        outputString += '    "' + family.name + ' Color Family":{\n';
        family.swatchGroup.forEach((swatch, index, array) => {
            let swatchName = createSwatchName(family.name, swatch.lightness, duplicateManger);

            outputString += '        "' + swatchName + '": {\n';
            outputString += '            "$value": "#' + swatch.hex + '",\n';
            outputString += '            "$type": "color"\n';
            if (prefsData.exportAccessibility) {
                outputString += '            "$extensions": {\n';
                outputString += '                "accessibility: "' + createAccessibilityComment(famData, famid, index) + '"';
                outputString += '            }'
            }
            outputString += '        }' + (index === array.length - 1 ? '' : ',') + '\n'

        });
        outputString += '    }' + (famid === array.length - 1 ? '' : ',') + '\n';
    });
    outputString += '}';
    return outputString;
}



function writeSVGCode(famData, lightnessData, prefsData) {
    let size = 120;
    let color = '#000000';
    let coords = {x:0,y:0};
    let canvasHeight = famData.length * size;
    let extraWide = false;
    let textContrastComment = '';
    famData.forEach((family, id) => {
        if (family.swatchGroup.length > lightnessData.steps) {
            extraWide = true
        }
    });

    let canvasWidth = (extraWide ? (lightnessData.steps + 1) : lightnessData.steps) * size;
    let svgData = '<svg width="' + canvasWidth + '" height="' + canvasHeight + '" viewBox="0 0 ' + canvasWidth + ' ' + canvasHeight + '" fill="none" xmlns="http://www.w3.org/2000/svg">\n';
    famData.forEach((family, famid) => {
        coords.y = famid * size;
        family.swatchGroup.forEach((swatch, swatchid) => {
            coords.x = swatchid * size
            color = colorString(prefsData.exportColorFormat, swatch, prefsData.colorSpace);

            if (prefsData.exportAccessibility) {
                textContrastComment = '<!-- ' + createAccessibilityComment(famData, famid, swatchid) + '-->';
            }

            let rect = '    <rect x="' + coords.x + '" y="' + coords.y + '" width="'+ size +'" height="'+ size +'" fill="'+ color +'" /> ' + textContrastComment + '\n';
            svgData = svgData + rect;
        });
    });
    svgData = svgData + '</svg>';
    return svgData;
}

function writeCSSCode(famData, prefsData) {
    let outputString = ':root {\n';
    let color = '#000000';
    let textContrastComment = '';
    famData.forEach((family, famid) => {	
        let name = family.name.replace(/\s/g, '-').toLowerCase();
        outputString = outputString + '    /* ' + family.name + ' */\n';
        let dupCheck; // number
        let dupCounter = 2;
        family.swatchGroup.forEach((swatch, index) => {
            let string;
            let lightnessRounded = Math.round(swatch.lightness);
            let nameNumber = lightnessRounded.toString();
            if (lightnessRounded === dupCheck) {
                nameNumber = nameNumber + '-' + dupCounter;
                dupCounter++;
            } else {
                dupCounter = 2
            }
            dupCheck = lightnessRounded;

            color = colorString(prefsData.exportColorFormat, swatch, prefsData.colorSpace);
            // if (prefsData.exportColorFormat === 'HSL') {
            //     color = 'hsl(' + swatch.hue + ', ' + swatch.saturation + ', ' + swatch.lightness + ')';
            // } else if (prefsData.exportColorFormat === 'RGB') {
            //     color = 'rgb(' + swatch.red + ', ' + swatch.green + ', ' + swatch.blue + ')';
            // } else {
            //     color = '#' + swatch.hex;
            // }

            if (prefsData.exportAccessibility) {
                textContrastComment = '/* ' + createAccessibilityComment(famData, famid, index) + ' */';
            }

            string = '    --' + name + '-' + nameNumber + ': ' + color + '; ' + textContrastComment + '\n';
            outputString = outputString + string;
        });
        outputString += '\n';
    });
    outputString += '}';
    return outputString;
}

function createSwatchName(famName, lightnessVal, dupManager) {
    let lightnessRounded = Math.round(lightnessVal);
    let nameNumber = lightnessRounded.toString();
    if (lightnessRounded === dupManager.number) {
        nameNumber = nameNumber + '-' + dupManager.counter;
        dupManager.counter++;
    } else {
        dupManager.counter = 2
    }
    dupManager.number = lightnessRounded;
    let outputString = famName + ' ' + nameNumber;
    return outputString;
}

function colorString(format, swatch, colorSpace) {
    // Expected formats: 'RGB', 'Hex', 'HSL'
    let colorString
    if (format === 'Hex') {
        colorString = '#' + swatch.hex;
    } else if (format === 'RGB') {
        colorString = 'rgb(' + swatch.red + ', ' + swatch.green + ', ' + swatch.blue + ')';
    } else if (format === 'HSL') {
        if (colorSpace === 'HCT') {
            const hct = {hue: swatch.hue, chroma: swatch.saturation, tone: swatch.lightness};
            const convertedHSL = hctToHSL(hct);
            colorString = 'hsl(' + convertedHSL.h + ', ' + convertedHSL.s + '%, ' + convertedHSL.l + '%)';
        } else {
            colorString = 'hsl(' + swatch.hue + ', ' + swatch.saturation + '%, ' + swatch.lightness + '%)';
        }
    } else {
        colorString = '#000000'
    }
    return colorString
}

function createAccessibilityComment(famData, famid, swatchid) {
    /* #ffffff text AA; #000000 text fail; */
    let string = '';
    famData[famid].swatchGroup[swatchid].textContrastData.forEach((textColor) => {
        if (textColor.pass) {
            string += '#' + textColor.color + ' text ' + textColor.label + '; '
        } else {
            string += '#' + textColor.color + ' text fail; ';
        }
    });
    return string;
}